import { render, staticRenderFns } from "./emplist.vue?vue&type=template&id=0ede4c32&"
import script from "./emplist.vue?vue&type=script&lang=js&"
export * from "./emplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports